var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { Component, Mixins } from 'vue-property-decorator';
import EntityService from "@/common/services/EntityService";
import LockService from "@/common/services/LockService";
import { Notification } from "@/common/services/notificationService";
import RouteService from "@/common/services/routeService";
import { Savable } from "../../common/mixins/Savable";
import { Validatable } from '@/common/mixins/Validatable';
import { Focusable } from "../../common/mixins/Focusable";
import { RecordState } from '@/common/types/RecordState';
import MasterDataConsumer from '@/common/mixins/MasterDataConsumer';
var TemplateBase = /** @class */ (function (_super) {
    __extends(TemplateBase, _super);
    function TemplateBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lockService = new LockService();
        _this.saveErrorFocused = false;
        _this.sending = false;
        _this.validating = false;
        _this.isValidated = false;
        return _this;
    }
    TemplateBase_1 = TemplateBase;
    Object.defineProperty(TemplateBase.prototype, "entityService", {
        get: function () {
            return new EntityService();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "routeService", {
        get: function () {
            return new RouteService(this.$router);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "features", {
        get: function () {
            var config = this.$store.state.vuexPageModule.configuration;
            return config.featureConfiguration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "instructionLinks", {
        get: function () {
            var config = this.$store.state.vuexPageModule.configuration;
            return config.instructionLinks;
        },
        enumerable: false,
        configurable: true
    });
    TemplateBase.prototype.isNotFirstTab = function () {
        return !this.routeService.isFirstIndex();
    };
    TemplateBase.prototype.isNotLastTab = function () {
        return !this.routeService.isLastIndex();
    };
    TemplateBase.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.saveTimeStamp = new Date();
                this.focusOnFirstTag("h1");
                return [2 /*return*/];
            });
        });
    };
    TemplateBase.prototype.unlockSection = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.waitUntilSaved()];
                    case 1:
                        _a.sent();
                        this.lock = false;
                        if (!(this.recordId
                            && this.section > 0
                            && this.sectionLockStatus.isLockedForUser
                            && this.sectionLockStatus.isLockedForApp)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.clearSectionLock()];
                    case 2:
                        _a.sent();
                        this.section = 0;
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.lockStatusSet = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, status, e_1, notification;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.section > 0)) return [3 /*break*/, 8];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        if (!!this.sectionLockStatus.isLocked) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.refreshLockState()];
                    case 2:
                        _a.sent();
                        if (this.sectionLockStatus.isLocked
                            && (this.sectionLockStatus.isLockedForAnotherUser
                                || this.sectionLockStatus.isLockedForAnotherApp))
                            this.refreshCurrentPage();
                        this.locking = true;
                        return [4 /*yield*/, this.entityService.postSectionLock(this.recordId, this.section, this.appId)];
                    case 3:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 5];
                        return [4 /*yield*/, response.json()];
                    case 4:
                        status = _a.sent();
                        this.$store.commit("vuexPageModule/SET_SECTION_LOCK_STATUS", status);
                        _a.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1 = _a.sent();
                        notification = this.$t("Entities.SaveFailed");
                        Notification.error(this, notification);
                        this.locking = false;
                        return [3 /*break*/, 8];
                    case 7:
                        this.locking = false;
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.modifiedStatusSet = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.section > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.waitUntilLocked()];
                    case 1:
                        _a.sent();
                        if (!(this.sectionLockStatus.isLockedForUser && this.sectionLockStatus.isLockedForApp)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.autoSave()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.clearSectionLock = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, status, e_2, notification;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, 5, 6]);
                        this.locking = true;
                        return [4 /*yield*/, this.entityService.clearSectionLock(this.recordId, this.section, this.appId)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        status = _a.sent();
                        this.$store.commit("vuexPageModule/SET_SECTION_LOCK_STATUS", status);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        e_2 = _a.sent();
                        notification = this.$t("Entities.GeneralError");
                        Notification.error(this, notification);
                        this.locking = false;
                        return [3 /*break*/, 6];
                    case 5:
                        this.locking = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TemplateBase.prototype, "loading", {
        get: function () {
            return this.$store.state.vuexPageModule.loading;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_LOADING", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "section", {
        get: function () {
            return this.$store.state.vuexPageModule.section;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_SECTION", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "appId", {
        get: function () {
            return this.$store.state.vuexPageModule.appId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "recordId", {
        get: function () {
            return this.$store.state.vuexPageModule.recordId;
        },
        set: function (id) {
            this.$store.commit("vuexPageModule/SET_RECORDID", id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "validationErrors", {
        get: function () {
            return this.$store.state.vuexPageModule.validationErrors;
        },
        set: function (errors) {
            this.$store.commit("vuexPageModule/SET_VALIDATIONERRORS", errors);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "hasValidationErrors", {
        get: function () {
            return this.validationErrors != null && this.validationErrors.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "hasCurrentSectionValidationErrors", {
        get: function () {
            var temp = this.$route.meta.section;
            if (temp) {
                var sectionNumber = Number(temp);
                var sectionErrors = this.$store.getters["vuexPageModule/sectionValidationErrors"](sectionNumber);
                return sectionErrors != null && sectionErrors.length > 0;
            }
            else {
                return false;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "recordable", {
        get: function () {
            return this.$store.state.vuexPageModule.recordable;
        },
        set: function (record) {
            this.$store.commit("vuexPageModule/SET_RECORDABLE", record);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "isRecordSendable", {
        get: function () {
            return this.isRecordOpenInWeb && this.hasProcuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "isRecordNew", {
        get: function () {
            return this.recordable.record != undefined &&
                this.recordable.record.state == RecordState.New;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "isRecordOpenInWeb", {
        get: function () {
            return this.recordable.record != undefined &&
                this.recordable.record.state == RecordState.OpenInWeb;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "shutdown", {
        get: function () {
            return this.$store.state.vuexPageModule.shutdown;
        },
        enumerable: false,
        configurable: true
    });
    TemplateBase.prototype.callAutoSave = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.entityService.autoSaveUpdate(this.recordable, this.section, this.appId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TemplateBase.prototype.autoSave = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, notification, notification, status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.dirty) return [3 /*break*/, 5];
                        this.saving = true;
                        this.incrementSavingInstances();
                        return [4 /*yield*/, this.callAutoSave()];
                    case 1:
                        response = _a.sent();
                        this.decrementSavingInstances();
                        if (!(this.savingInstances == 0)) return [3 /*break*/, 5];
                        if (!(response === null)) return [3 /*break*/, 2];
                        notification = this.$t("Entities.SaveFailed");
                        Notification.error(this, notification);
                        this.dirty = false;
                        this.modified = false;
                        return [3 /*break*/, 4];
                    case 2:
                        if (response.ok) {
                            this.saved = true;
                            this.saveTimeStamp = new Date();
                            this.saveErrorFocused = false;
                        }
                        else {
                            if (response.status == 406 || response.status == 409) {
                                // If entity is past deadline or in a non-editable state (406) OR
                                // the entity is locked for another user. Then 'cancel' the edit by unsetting
                                // dirty and modified flags. 
                                this.dirty = false;
                                this.modified = false;
                                this.saving = false;
                                this.refreshCurrentPage();
                            }
                            else {
                                this.saveFailed = true;
                            }
                            if (!this.saveErrorFocused) {
                                this.saveErrorFocused = true;
                                this.focusOnLastClass("save-failed");
                            }
                            notification = this.$t("Entities.SaveFailed");
                            Notification.error(this, notification);
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        status = _a.sent();
                        this.refreshLockState(status);
                        _a.label = 4;
                    case 4:
                        this.saving = false;
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.addDirtySubscription = function () {
        var _this = this;
        TemplateBase_1.dirtySubscription = this.$store.subscribe(function (mutation, state) {
            if (mutation.type === "vuexPageModule/SET_LOCK" && mutation.payload === true) {
                _this.lockStatusSet();
            }
            if (mutation.type === "vuexPageModule/SET_MODIFIED" && mutation.payload === true) {
                if (!_this.shutdown) {
                    _this.modifiedStatusSet();
                }
            }
        });
    };
    TemplateBase.prototype.disableDirtySubscription = function () {
        if (TemplateBase_1.dirtySubscription != undefined) {
            TemplateBase_1.dirtySubscription();
        }
    };
    Object.defineProperty(TemplateBase.prototype, "hasProcuration", {
        get: function () {
            var user = this.$store.state.vuexPageModule.currentUser;
            if (user) {
                return user.hasProcuration;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    TemplateBase.prototype.send = function (recordType) {
        return __awaiter(this, void 0, void 0, function () {
            var errors, isSuccess, e_3, notification, notification;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!confirm(this.$i18n.t("Confirmation.SendToStea").toString())) return [3 /*break*/, 5];
                        this.sending = true;
                        errors = [];
                        isSuccess = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.entityService.send(recordType, this.recordId, this.languageCode)];
                    case 2:
                        errors = _a.sent();
                        isSuccess = (errors.length == 0);
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        console.error("Send failed", e_3);
                        return [3 /*break*/, 4];
                    case 4:
                        // refresh vee-validate validation messages
                        this.refreshValidationMessages();
                        // set validationErrors from the back-end
                        this.validationErrors = errors;
                        if (isSuccess) {
                            notification = this.$t("Entities.SendSuccess");
                            Notification.success(this, notification);
                            setTimeout(function () {
                                _this.sending = false;
                                _this.routeService.goToRecordHistory();
                            }, 400);
                        }
                        else {
                            notification = this.$t("Entities.SendFailed");
                            Notification.error(this, notification);
                            setTimeout(function () {
                                _this.sending = false;
                            }, 400);
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.delete = function (recordType) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!confirm(this.$i18n.t("Confirmation.DeleteForm").toString())) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.entityService.deleteRecord(recordType, this.recordId)];
                    case 1:
                        _a.sent();
                        this.routeService.goToRecordHistory();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.validate = function (recordType) {
        return __awaiter(this, void 0, void 0, function () {
            var errors, e_4, notification;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validating = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.entityService.validationErrors(recordType, this.recordId)];
                    case 2:
                        errors = _a.sent();
                        // refresh vee-validate validation messages
                        this.refreshValidationMessages();
                        // set validationErrors from the back-end
                        this.validationErrors = errors;
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        notification = this.$t("Entities.UnexpectedValidationError");
                        Notification.error(this, notification);
                        this.validationErrors = [];
                        return [3 /*break*/, 4];
                    case 4:
                        setTimeout(function () {
                            _this.validating = false;
                            _this.isValidated = true;
                        }, 400);
                        return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.refreshValidationMessages = function () {
        return __awaiter(this, void 0, Promise, function () {
            var obs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        obs = this.validationObserver;
                        if (!(obs != undefined && this.isFunction(obs.validate))) return [3 /*break*/, 2];
                        return [4 /*yield*/, obs.validate()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, false];
                }
            });
        });
    };
    Object.defineProperty(TemplateBase.prototype, "validationObserver", {
        get: function () {
            // Find the ValidationObserver by walking up the component tree
            var temp = this;
            var obs = temp.$refs["observer"];
            while (obs == undefined && temp.$parent != undefined) {
                temp = temp.$parent;
                obs = temp.$refs["observer"];
            }
            return obs;
        },
        enumerable: false,
        configurable: true
    });
    TemplateBase.prototype.isFunction = function (functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    };
    TemplateBase.prototype.manualValidate = function (recordType) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validating = true;
                        return [4 /*yield*/, this.waitUntilSaved()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.validate(recordType)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.focusOnErrorsAndNotify()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.focusOnErrorsAndNotify = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        if (!this.hasCurrentSectionValidationErrors) {
                            Notification.success(this, this.$t("Notification.Validation_Successful"));
                        }
                        else {
                            Notification.error(this, this.$t("Notification.Validation_Failed"));
                            this.focusOnValidationErrors();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.sendValidate = function (recordType, hasTabs) {
        if (hasTabs === void 0) { hasTabs = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validating = true;
                        return [4 /*yield*/, this.waitUntilSaved()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.validate(recordType)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.sendValidateFocusOnErrorsAndNotify(recordType, hasTabs)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.sendValidateFocusOnErrorsAndNotify = function (recordType, hasTabs) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        if (this.validationErrors !== null && this.validationErrors.length > 0) {
                            this.focusOnValidationErrors();
                            Notification.error(this, this.errorNotificationMessage(recordType, hasTabs), this.errorNotificationMessage(recordType, hasTabs), 10000);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TemplateBase.prototype, "languageCode", {
        get: function () {
            return this.$store.state.vuexPageModule.language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "sendTooltip", {
        get: function () {
            var tooltip = null;
            if (this.isRecordNew) {
                tooltip = this.$t("StartByModifying").toString();
            }
            else if (!this.hasProcuration) {
                tooltip = this.$t("Send.NeedsProcuration").toString();
            }
            else if (!this.isValidated || this.hasValidationErrors) {
                tooltip = this.$t("Send.HasValidationErrors").toString();
            }
            return tooltip;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Refresh current section lock state
     */
    TemplateBase.prototype.refreshLockState = function (lock) {
        return __awaiter(this, void 0, void 0, function () {
            var status, responseFailed, response, notification, e_5, notification;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        status = lock;
                        responseFailed = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        this.locking = true;
                        if (!!status) return [3 /*break*/, 5];
                        if (!this.section || this.section <= 0 || !this.recordId)
                            throw new Error("Cannot fetch lock state without section or record id.");
                        return [4 /*yield*/, this.entityService.getLockState(this.recordId, this.section, this.appId)];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json()];
                    case 3:
                        status = (_a.sent());
                        return [3 /*break*/, 5];
                    case 4:
                        responseFailed = true;
                        notification = this.$t("Entities.SaveFailed");
                        Notification.error(this, notification);
                        _a.label = 5;
                    case 5:
                        if (!responseFailed) {
                            this.$store.commit("vuexPageModule/SET_SECTION_LOCK_STATUS", status);
                        }
                        this.$store.commit("vuexPageModule/SET_FLAG", "lockChecked");
                        return [3 /*break*/, 8];
                    case 6:
                        e_5 = _a.sent();
                        notification = this.$t("Entities.SaveFailed");
                        Notification.error(this, notification);
                        this.locking = false;
                        return [3 /*break*/, 8];
                    case 7:
                        this.locking = false;
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.fetchFailedKey = function (recordType) {
        switch (recordType) {
            case "ExpandedStrategyAndBudgetaryEstimate":
                return "Expanded.FetchFailed";
            case "PaymentRequestExpenseReport":
                return "PaymentRequestER.FetchFailed";
            default:
                return recordType + ".FetchFailed";
        }
    };
    /**
    * Refreshes the recordable
    * @param recordType Type of the recordable
    */
    TemplateBase.prototype.refreshRecordable = function (recordType) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_6, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, this.entityService.getRecordable(recordType, this.recordId)];
                    case 1:
                        _a.recordable = _b.sent();
                        this.$store.commit("vuexPageModule/SET_FLAG", "dataRetrieved");
                        return [3 /*break*/, 4];
                    case 2:
                        e_6 = _b.sent();
                        error = this.$t(this.fetchFailedKey(recordType));
                        Notification.error(this, error);
                        this.routeService.goToFrontPage();
                        throw e_6;
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Refresh the record validation errors. On error, shows a notification but does not clean the validationErrors array.
     * @param recordType Type of the recordable
     * @param forceValidation Forces recordable validation in cases where validation would normally be skipped. Such as when recordable is in New state.
     */
    TemplateBase.prototype.refreshValidationErrors = function (recordType) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_7, notification;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, 7, 9]);
                        this.validating = true;
                        if (!this.isRecordOpenInWeb) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.entityService.validationErrors(recordType, this.recordId)];
                    case 1:
                        _a.validationErrors = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.$store.commit("vuexPageModule/SET_FLAG", "validationDone");
                        return [4 /*yield*/, this.$nextTick()];
                    case 3:
                        _b.sent();
                        if (!((this.isRecordOpenInWeb || this.hasCurrentSectionValidationErrors) && !this.isReadOnly)) return [3 /*break*/, 5];
                        // Vee-validation messages are refreshed only after the next update cycle completes
                        return [4 /*yield*/, this.refreshValidationMessages()];
                    case 4:
                        // Vee-validation messages are refreshed only after the next update cycle completes
                        _b.sent();
                        _b.label = 5;
                    case 5: return [3 /*break*/, 9];
                    case 6:
                        e_7 = _b.sent();
                        notification = this.$t("Entities.UnexpectedValidationError");
                        Notification.error(this, notification);
                        this.validationErrors = [];
                        // Validation is marked as done even if there is an error
                        this.$store.commit("vuexPageModule/SET_FLAG", "validationDone");
                        throw e_7;
                    case 7: return [4 /*yield*/, this.sleep(400)];
                    case 8:
                        _b.sent();
                        this.validating = false;
                        if (this.isRecordOpenInWeb) {
                            this.isValidated = true;
                        }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.sleep = function (ms) {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    };
    Object.defineProperty(TemplateBase.prototype, "sectionRenderReady", {
        get: function () {
            return this.$store.getters["vuexPageModule/sectionRenderReady"];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "lockReason", {
        get: function () {
            var reason = '';
            if (this.sectionLockStatus.isLocked) {
                if (this.sectionLockStatus.isLockedState)
                    reason = this.lockedStateReason;
                else if (this.sectionLockStatus.isPastDeadline)
                    reason = this.pastDeadlineReason;
                else if (this.sectionLockStatus.isLockedForAnotherUser)
                    reason = this.lockedForAnotherUserReason;
                else if (this.sectionLockStatus.isLockedForAnotherApp)
                    reason = this.lockedForAnotherAppReason;
            }
            return reason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "lockedStateReason", {
        get: function () {
            return this.$t('Save.LockedState').toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "pastDeadlineReason", {
        get: function () {
            return this.$t('Save.PastDeadline').toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "lockedForAnotherUserReason", {
        get: function () {
            var userName = this.sectionLockStatus.lockedUserName;
            return !!userName
                ? this.$t('Save.LockedForUser', [userName]).toString()
                : this.$t('Save.LockedForOtherUser').toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateBase.prototype, "lockedForAnotherAppReason", {
        get: function () {
            return this.$t('Save.LockedForOtherApp').toString();
        },
        enumerable: false,
        configurable: true
    });
    TemplateBase.prototype.openLock = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, this.lockService.swapLockTo(this.recordId, this.section, this.appId)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_8 = _a.sent();
                        console.error(e_8);
                        return [3 /*break*/, 4];
                    case 3:
                        this.refreshCurrentPage();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TemplateBase.prototype.refreshCurrentPage = function () {
        this.$store.commit("vuexPageModule/SET_UPDATING", true);
        this.$router.go(0);
    };
    TemplateBase.prototype.notificationMessage = function (count) {
        var bR = "<br/>";
        return count > 1
            ? bR + this.$t("Notification.CheckTabs")
            : bR + this.$t("Notification.CheckTab");
    };
    TemplateBase.prototype.errorNotificationMessage = function (recordType, hasTabs) {
        var _this = this;
        var tabNames = "";
        var uLStart = "<ul>";
        var uLEnd = "</ul>";
        var lIStart = "<li>";
        var lIEnd = "</li>";
        var groupIds = __spread(new Set(this.validationErrors.map(function (v) { return v.groupId; })));
        var errorNotificationMessage = hasTabs
            ? this.$t("Notification.Form_Validation_Failed") + this.notificationMessage(groupIds.length)
            : this.$t("Notification.Form_Validation_Failed");
        if (hasTabs) {
            Array.from(groupIds).forEach(function (groupId) {
                switch (recordType) {
                    case "AidApplication":
                        uLStart;
                        if (groupId === 1) {
                            tabNames += lIStart + _this.$t("AidApplication.Title_BasicInfo") + lIEnd;
                        }
                        else if (groupId === 2) {
                            tabNames += lIStart + _this.$t("AidApplication.Title_Operation") + lIEnd;
                        }
                        else if (groupId === 3) {
                            tabNames += lIStart + _this.$t("AidApplication.Title_Partners") + lIEnd;
                        }
                        else if (groupId === 4) {
                            tabNames += lIStart + _this.$t("AidApplication.Title_BudgetaryEstimate") + lIEnd;
                        }
                        else if (groupId === 5) {
                            tabNames += lIStart + _this.$t("AidApplication.Menu.ContactInfo") + lIEnd;
                        }
                        uLEnd;
                        break;
                    case "OrganisationYearlyReport":
                        uLStart;
                        if (groupId === 1) {
                            tabNames += lIStart + _this.$t("Menu.Organisation") + lIEnd;
                        }
                        else if (groupId === 2) {
                            tabNames += lIStart + _this.$t("Title_ProfitsAndExpenses") + lIEnd;
                        }
                        else if (groupId === 3) {
                            tabNames += lIStart + _this.$t("Title_BalanceSheet") + lIEnd;
                        }
                        else if (groupId === 4) {
                            tabNames += lIStart + _this.$t("Title_Administration") + lIEnd;
                        }
                        else if (groupId === 5) {
                            tabNames += lIStart + _this.$t("Title_InternalMonitoring") + lIEnd;
                        }
                        else if (groupId === 6) {
                            tabNames += lIStart + _this.$t("Title_Attachments") + lIEnd;
                        }
                        else if (groupId === 7) {
                            tabNames += lIStart + _this.$t("Menu.ContactInfo") + lIEnd;
                        }
                        uLEnd;
                        break;
                    case "SummaryReport":
                        uLStart;
                        if (groupId === 1) {
                            tabNames += lIStart + _this.$t("SummaryReport.Menu.BasicInfo") + lIEnd;
                        }
                        else if (groupId === 2) {
                            tabNames += lIStart + _this.$t("SummaryReport.Menu.Collaboration") + lIEnd;
                        }
                        else if (groupId === 3) {
                            tabNames += lIStart + _this.$t("SummaryReport.Menu.TargetGroups") + lIEnd;
                        }
                        else if (groupId === 4) {
                            tabNames += lIStart + _this.$t("SummaryReport.Menu.Operation") + lIEnd;
                        }
                        else if (groupId === 5) {
                            tabNames += lIStart + _this.$t("SummaryReport.Menu.Results") + lIEnd;
                        }
                        uLEnd;
                        break;
                    case "InvestmentReport":
                        uLStart;
                        if (groupId === 1) {
                            tabNames += lIStart + _this.$t("InvestmentReport.Menu.BasicInfo") + lIEnd;
                        }
                        else if (groupId === 2) {
                            tabNames += lIStart + _this.$t("InvestmentReport.Menu.Finances") + lIEnd;
                        }
                        else if (groupId === 3) {
                            tabNames += lIStart + _this.$t("InvestmentReport.Menu.ContactInfo") + lIEnd;
                        }
                        uLEnd;
                        break;
                    case "ExpandedStrategyAndBudgetaryEstimate":
                        uLStart;
                        if (groupId === 1) {
                            tabNames += lIStart + _this.$t("Expanded.Title_BasicInfo") + lIEnd;
                        }
                        else if (groupId === 2) {
                            tabNames += lIStart + _this.$t("Expanded.Title_Operation") + lIEnd;
                        }
                        else if (groupId === 3) {
                            tabNames += lIStart + _this.$t("Expanded.Title_BudgetaryEstimate") + lIEnd;
                        }
                        uLEnd;
                        break;
                }
            });
        }
        return errorNotificationMessage + tabNames;
    };
    TemplateBase.prototype.userCantSendOrDeleteNotificationMessage = function (isSending) {
        if (isSending === void 0) { isSending = true; }
        return isSending
            ? Notification.error(this, this.$t("Send.NeedsProcuration").toString(), this.$t("Send.NeedsProcuration").toString(), 10000)
            : Notification.error(this, this.$t("Btn_Delete_Disabled_Description").toString(), this.$t("Btn_Delete_Disabled_Description").toString(), 10000);
    };
    var TemplateBase_1;
    TemplateBase = TemplateBase_1 = __decorate([
        Component({
            name: 'TemplateBase'
        })
    ], TemplateBase);
    return TemplateBase;
}(Mixins(Savable, Validatable, Focusable, MasterDataConsumer)));
export default TemplateBase;
